import { Component, ElementRef, Renderer2, ViewChild, EventEmitter, Input, Output, SimpleChanges, input } from '@angular/core';
import { FileUploadModel } from '../../../../shared/flexible-file-upload/flexible-file-upload.component';
import { ProjectService } from '../../../services/project.service';
import { MessageService } from '../../../services/message.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { StorageService } from '../../../../Common/services/storage.service';
import { UserRoleServiceService } from '../../../../shared/services/user-role-service.service';
import { ErrorLoggerService } from '../../../../shared/services/error-logger.service';
import { fileBaseVM, InstructionImagesVm, InstructionsVM, ProjectInstructionsVM } from '../../../models/project-vm';
import { UserLogin } from '../../../../Common/models/user.login';
import { Editor, Toolbar } from 'ngx-editor';
import { ProjectTemplateInstructionsVm } from '../../../models/project-vm';
import * as _ from 'lodash';
import jspdf, { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';
import { EmailNotificationService } from '../../../../Common/services/email-notification.service';
import { Category } from '../../../../administration/models/models-vm';
import { ProjectDto } from '../../../../Common/models/emailrequestdto';
import { ActionItems } from '../../../../Common/Constants/common.constants';
import { ComponentMessages, ProjectConstants } from '../../../constants/component-messages';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrl: './instructions.component.scss'
})
export class InstructionsComponent {
  @Input() selectedInstructionsVM: InstructionsVM | null|undefined ;
  @Input() projectTemplateInstruction: ProjectTemplateInstructionsVm[] = [];
  @Input() disableFields: boolean = false;
  @Input() selStoreDetails?: any | null = null;
  @Output() notifyInstructionsObject = new EventEmitter<InstructionsVM>();
  @Output() selectedTemplateData = new EventEmitter<ProjectTemplateInstructionsVm[]>();
  selectedFiles: FileUploadModel | null = null;
  selFiles: FileUploadModel[] = []; 
  disableFileUpload: boolean = false;
  uInfo: UserLogin | null | undefined;
  templateone = true;
  isRadioChecked = true;
  fileName: string = '';
  checked: boolean = false;
  templateOne: boolean = false;
  rawHtml: string = `
    <h1>Your PDF Content Here</h1>
    <p>This content will be converted to PDF when you click the button.</p>
  `;

  tempInstructionsVm: ProjectTemplateInstructionsVm[] = [];
  instructionsVm: ProjectInstructionsVM[] = [];
  instructionImagesVm: InstructionImagesVm[] = [];
  @ViewChild('fileInput') fileInput!: ElementRef;

  editor1!: Editor;
  editor2!: Editor;
  editor3!: Editor;
  editor4!: Editor;
  editor5!: Editor;
  editor6!: Editor;
  editor7!: Editor;

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  instructionTextHtml11 = '';
  instructionTextHtml21 = '';
  instructionTextHtml22 = '';
  instructionTextHtml23 = '';
  instructionTextHtml31 = '';
  instructionTextHtml32 = '';
  instructionTextHtml33 = '';

  templateId = 0;

  activeColor: string = 'green';
  baseColor: string = '#ccc';
  overlayColor: string = 'rgba(255,255,255,0.5)';

  dragging: boolean = false;
  loaded: boolean = false;
  imageLoaded: boolean = false;
  imageSrc: any[] = [];
  imageId: number = 0;
  imageNumber: number = 0;
  clonned: any;

  @Input() selectedCategoryList: Category[] = [];

  constructor(private projectService: ProjectService,
    private msgService: MessageService,
    private ngxService: NgxUiLoaderService,
    private storageService: StorageService,
    private userRoleService: UserRoleServiceService,
    private errorLogService: ErrorLoggerService,
    private renderer: Renderer2,
    private unsavedChangesService: UnsavedChangesService,
    private emailService: EmailNotificationService
  ) {
    this.selectedInstructionsVM = new InstructionsVM(); 
   }
   onAnyFieldValueChange(e:boolean){
    if(e){
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }

   setSelFilesFromVM(): void {
    if (this.selectedInstructionsVM?.files) {
      this.selFiles = this.selectedInstructionsVM.files.map(file=> ({
        fileName:file.filename || '', 
        base64Bytes: file.base64Bytes || null,
        fileChanged: file.fileChanged || false,
        isFileDelted: false  
      }));
    }
  }
  
  async ngOnInit() {
    this.uInfo = this.storageService.getItem<UserLogin>("UserInfo");
        this.selectedInstructionsVM = new InstructionsVM();
    if (this.selectedInstructionsVM != null) {
      this.selectedInstructionsVM.createdBy = this.uInfo?.userID;
    }
    this.editor1 = new Editor();
    this.editor2 = new Editor();
    this.editor3 = new Editor();
    this.editor4 = new Editor();
    this.editor5 = new Editor();
    this.editor6 = new Editor();
    this.editor7 = new Editor();

  }



  async ngOnChanges(changes: SimpleChanges) {
    // if (changes['projectTemplateInstruction'].currentValue != changes['projectTemplateInstruction'].previousValue) {
    //   this.clonned = _.cloneDeep(this.projectTemplateInstruction);
    //   if (this.projectTemplateInstruction.length != 0) {
      
    //     this.tempInstructionsVm = this.projectTemplateInstruction;
    //     this.tempInstructionsVm.forEach(x => {
    //       this.templateId = x.templateID,
    //         this.instructionTextHtml11 = x.instructions[0].text,
    //         this.instructionImagesVm = x.instructions[0].images
    //       if (this.templateId != 0) {
    //         this.checked = true;
    //       }

    //     })
    //     if (this.templateId == 1) {
    //       this.templateOne = true;
    //     }
    //   }

    // }

    if (changes['selectedInstructionsVM'] && this.selectedInstructionsVM) {
      this.setSelFilesFromVM();  
    }
    else {
      this.selectedInstructionsVM = new InstructionsVM();
      this.selectedInstructionsVM.createdBy = this.uInfo?.userID;
    }
  
  }

  deleteFile(event:any):void{
    if (event.isFileDeleted && this.selectedInstructionsVM != null && this.selectedInstructionsVM.files != null) {
      // Ensure files array and its first element are not null or undefined
      if (this.selectedInstructionsVM.files.length > 0 && this.selectedInstructionsVM.files[0] != null) {
        this.selectedInstructionsVM.files[event.rowIndex].isFileDeleted = true;
        this.selectedInstructionsVM.files[event.rowIndex].fileChanged = true;  // Safe assignment
      }
      this.notifyInstructionsObject.emit(this.selectedInstructionsVM!);
      this.errorLogService.logMessage(event, 'InstructionsComponent > handleFileUpload');
    }
  }


  // handleFileUpload(event: any) :void{
  //   console.log('Received event:', event);

  //   if (!event || !Array.isArray(event)) {
  //     console.error('Invalid event data received:', event);
  //     return;
  //   }
  //   if (!this.selectedInstructionsVM) {
  //     this.selectedInstructionsVM = new InstructionsVM();
  //   }

   
  //   if (!this.selectedInstructionsVM.files) {
  //     this.selectedInstructionsVM.files = [];
  //   }
  //   for (const fileInfo of event) {
  //     if (fileInfo && fileInfo.fileName) {
  //       const newFileInfo = new fileBaseVM();
  //       newFileInfo.filename = fileInfo.fileName;
  //       newFileInfo.fileChanged = fileInfo.fileChanged;
  //       newFileInfo.base64Bytes = fileInfo.base64Bytes;
  //       this.selectedInstructionsVM.files.push(newFileInfo);
  //     } else {
  //       console.warn('Invalid fileInfo object:', fileInfo);
  //     }
  //   }
  
  //   // Emit the updated object if necessary
  //   this.notifyInstructionsObject.emit(this.selectedInstructionsVM);
  
  //   // Log the updated files array for debugging
  //   this.errorLogService.logMessage(this.selectedInstructionsVM.files, 'InstructionsComponent > FilesReceived from Fileupload Control');
  // }
  
  handleFileUpload(event: any): void { 
    if (!event || !Array.isArray(event)) {
      console.error('Invalid event data received:', event);
      return;
    }
  
    if (!this.selectedInstructionsVM) {
      this.selectedInstructionsVM = new InstructionsVM();
    }
  
    // Initialize files if it doesn't exist
    if (!this.selectedInstructionsVM.files) {
      this.selectedInstructionsVM.files = [];
    }
  
    
    const existingFilenames = new Set(this.selectedInstructionsVM.files.map(file => file.filename));
    for (const fileInfo of event) {
      if (fileInfo && fileInfo.fileName) {
        if (!existingFilenames.has(fileInfo.fileName)) {
          const newFileInfo = new fileBaseVM();
          newFileInfo.filename = fileInfo.fileName;
          newFileInfo.fileChanged = fileInfo.fileChanged;
          newFileInfo.base64Bytes = fileInfo.base64Bytes;
          this.selectedInstructionsVM.files.push(newFileInfo);
          existingFilenames.add(fileInfo.fileName);
        } else {
          console.warn('Duplicate file detected, skipping:', fileInfo.fileName);
        }
      } else {
        console.warn('Invalid fileInfo object:', fileInfo);
      }
    }

    this.notifyInstructionsObject.emit(this.selectedInstructionsVM);
  
    // Log the updated files array for debugging
    this.errorLogService.logMessage(this.selectedInstructionsVM.files, 'InstructionsComponent > FilesReceived from Fileupload Control');
  }
  
  //Below are code for the new drag and drop
  handleDragEnter() {
    this.dragging = true;
  }
  handleDragLeave() {
    this.dragging = false;
  }

  handleDrop(e: any, id: any) {
    e.preventDefault();
    this.dragging = false;
    this.handleInputChange(e, id);
  }

  handleImageLoad() {
    this.imageLoaded = true;
  }

  handleInputChange(e: any, id: any) {
    this.imageId = id;
    this.fileName = '';
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      return;
    }

    this.loaded = false;
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.onload = (event: any) => {
      const base64String = event.target.result;

      this.instructionImagesVm.push({
        imageID: this.imageId,
        image: file.name,
        base64Bytes: base64String
      });
      this.imageLoaded = true; // Update the image loaded state
    };
    reader.readAsDataURL(file);
    this.fileName = file.name;
  }

  _handleReaderLoaded(e: any) {
    var reader = e.target;
    this.imageSrc.push({
      id: (this.imageNumber + 2),
      img: reader.result
    });

    this.loaded = true;

  }

























  ngOnDestroy(): void {
    this.editor1.destroy();
    this.editor2.destroy();
    this.editor3.destroy();
    this.editor4.destroy();
    this.editor5.destroy();
    this.editor6.destroy();
    this.editor7.destroy();
  }











  // Template Area - not of scope as of now
  prepareDataForTemplateOne() {
    const instructionsVmData = {
      projectInstructionID: 0,
      images: this.instructionImagesVm,
      projectTemplateID: 0,
      textID: 11,
      text: this.instructionTextHtml11
    };

    // Replace the data at the 0th index
    this.instructionsVm[0] = instructionsVmData;

    // Define the new data you want to insert
    const tempInstructionsVmData = {
      instructions: this.instructionsVm,
      projectTemplateID: 0,
      refID: 0,
      templateID: this.templateId
    };

    // Replace the data at the 0th index
    this.tempInstructionsVm[0] = tempInstructionsVmData;
  }


  templateOneFinalData() {

    this.prepareDataForTemplateOne();

    this.selectedTemplateData.emit(this.tempInstructionsVm); 

  }

  onDeleteInstructionImageFile(index: any) {
    this.instructionImagesVm.splice(index, 1);
  }

  onTemplateChange(event: any) {
    this.templateId = event.target.value;
  }

  selectTemplateOne() {
    this.templateOne = true;
    this.templateId = 1;
  }

  onCancel() {
    this.tempInstructionsVm = this.clonned;
    this.selectedTemplateData.emit(this.tempInstructionsVm); 
  }
  exportAsPDF() {

    this.prepareDataForTemplateOne();

    var htmlString = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Image Gallery with Descriptions</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      margin: 0;
      padding: 0;
      background-color: #f4f4f4;
      color: #333;
    }
    .gallery {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      justify-content: center;
      padding: 20px;
    }
    .gallery-item {
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      overflow: hidden;
      width: 300px;
    }
    .gallery-item img {
      width: 100%;
      height: auto;
      display: block;
    }
    .gallery-item .description {
      padding: 15px;
      text-align: center;
    }
    .gallery-item .description h3 {
      margin: 0 0 10px;
      font-size: 18px;
    }
    .gallery-item .description p {
      margin: 0;
      color: #666;
    }
  </style>
</head>
<body>`;
    htmlString =
      htmlString + `
  <h1 style="text-align: center; margin-top: 20px;">`+ this.tempInstructionsVm[0].instructions[0].text + `</h1>`;
    for (var i = 0; i < this.tempInstructionsVm[0].instructions[0].images.length; i++) {
      htmlString = htmlString + ` <img src="` + this.tempInstructionsVm[0].instructions[0].images[i].base64Bytes + `" alt = "Placeholder Image 2"  style="margin-top:15px; margin-right:15px;">`;

    }
  

    htmlString = htmlString +`</body>
</html>
`;

    let data = document.getElementById('MyDIv') as HTMLElement;
    data.style.display = "block";
    data.innerHTML = htmlString;
    html2canvas(data, { scale: 2 }).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png');

      // Create a new jsPDF instance
      let pdf = new jsPDF('p', 'cm', 'a4'); // Portrait mode, cm units, A4 size

      // Get PDF dimensions in mm (A4 size is 210 x 297 mm)
      const pdfWidth = 21;  // A4 width in cm
      const pdfHeight = 29.7; // A4 height in cm

      // Calculate the image dimensions for the PDF
      const imgWidth = pdfWidth;
      const imgHeight = canvas.height * imgWidth / canvas.width; // Maintain aspect ratio

      // Add the image to the PDF
      pdf.addImage(contentDataURL, 'PNG', 0, 0, imgWidth, imgHeight);

      // Save the PDF
      pdf.save('TemplateInstruction.pdf');


      setTimeout(() => {
        data.style.display = "none";

      }, 3000);
    });


  }
  //generatePDF() {
  //  // Create a temporary element to hold the HTML content
  //  const tempElement = document.createElement('div');
  //  tempElement.innerHTML = this.rawHtml;
  //  document.body.appendChild(tempElement);

  //  // Options for html2pdf
  //  const options = {
  //    margin: [0.5, 0.5, 0.5, 0.5],
  //    filename: 'document.pdf',
  //    image: { type: 'jpeg', quality: 0.98 },
  //    html2canvas: { scale: 2 },
  //    jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
  //  };

  //  // Generate the PDF and trigger download
  //  html2pdf().from(tempElement).set(options).save().then(() => {
  //    // Remove the temporary element after PDF generation
  //    document.body.removeChild(tempElement);
  //  });
  //}

  showReminderDialog() {

    if (this.selStoreDetails.projectDetails.projectId > 0) {

      const project: ProjectDto = {
        projectID: this.selStoreDetails.projectDetails.projectId,
        vendorID: Number(this.selStoreDetails.projectDetails.vendorId),
        projectTitle: this.selStoreDetails.projectDetails.projectTitle,
        projectType: this.selStoreDetails.projectDetails.type,
        actionItem: ActionItems.INSTRUCTIONS,
        userID: this.selStoreDetails.projectDetails.ctRequester
      };

      this.emailService.open(this.selectedCategoryList, project);
    }
    else{
      this.msgService.htmlError(ProjectConstants.VALIDATION_REMINDER_EMAIL);
    }
  }
  
}
